<template>

    <v-section bg="grad">
        <h3 class="mb-30">Activate and retain your users with automations</h3>
        <div class="campaigns">
            <div v-for="(campaign, c) in campaigns" :key="`campaign-${c}`" class="campaign">
                <div class="campaign-header">
                    <i class="fas fa-paper-plane text-primary mr-10"></i>
                    <span>{{ campaign.title }}</span>
                </div>
                <div class="campaign-body">
                    <div class="actions">
                        <div v-for="(action, a) in campaign.actions" :key="`campaign-${c}-${action}-${a}`" class="action">
                            <v-icon :symbol="'action-' + action" :size="40" :radius="3" />
                            <i v-if="a < campaign.actions.length - 1" class="fas fa-arrow-right ml-5 mr-5"></i>
                        </div>
                    </div>
                    <p class="small m-0">{{ campaign.desc }}</p>
                </div>
            </div>
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    .campaigns {
        display: grid;
        gap: 15px;
        grid-template-columns: 1fr 1fr 1fr;
        @media (max-width: map-get($grid-breakpoints, 'lg')) {
            grid-template-columns: 1fr 1fr;
        }
        @media (max-width: map-get($grid-breakpoints, 'md')) {
            grid-template-columns: 1fr;
        }
    }

    .campaign {
        overflow: hidden;
        text-align: left;
        .campaign-header {
            @include font-semibold(15px);
            background: $color-bg;
            border: 1px solid $color-rule;
            border-bottom: none;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: $color-text;
            line-height: normal;
            padding: 15px;
            text-align: left;
        }
        .campaign-body {
            background: #fff;
            border: 1px solid $color-rule;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            padding: 20px;
            p {
                text-align: left;
            }
            .actions {
                display: flex;
                font-size: 12px;
                margin-bottom: 15px;
                .action {
                    align-items: center;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
    }

</style>

<script>

export default {

    data() {
        return {
            campaigns: [
                {
                    title: 'Onboarding Sequence',
                    actions: ['delay', 'email', 'delay', 'email'],
                    desc: 'Send a drip campaign to educate new customers about your product.',
                },
                {
                    title: 'Reactivation Sequence',
                    actions: ['delay', 'condition', 'email'],
                    desc: 'Send an email to customers that haven’t used your product in a while.',
                },
                {
                    title: 'New Signup Alert',
                    actions: ['discord', 'slack'],
                    desc: 'Send your team a Slack or Discord alert when new customers sign up.',
                },
                {
                    title: 'Usage Alert',
                    actions: ['condition', 'email', 'twilio'],
                    desc: 'Send customers a message when they have reached their plan limits.',
                },
                {
                    title: 'Automated Review Request',
                    actions: ['email', 'twilio'],
                    desc: 'Request a TrustPilot, G2, or Capterra rating from loyal customers.',
                },
                {
                    title: 'Add to 3rd Party CRM',
                    actions: ['condition', 'zapier'],
                    desc: 'Send customer data to a CRM, plus 3,000+ other apps, with Zapier.',
                },
            ],
        }
    },

}

</script>